<div class="input-shell" [class.input-shell--has-icon]="icon">
  @if (icon) {
    <app-icon
      class="input-shell__icon"
      [name]="icon"
      size="sm"
      color="custom"
      customColor="currentColor"
      role="presentation"
    />
  }
  <ng-content />
</div>
<label class="input-label" [attr.for]="inputId ?? null">{{ label }}</label>
